import React, { Component } from "react";
import { Row, Col } from "antd";
import { withRouter } from "react-router-dom";
import { withAppContext } from "../store/contextStore";
import ValueTracker from "../common/ValueTracker";

const NAVY = "#1A2280";

// Stage 1: standalone public route for the Value Tracker, reachable directly
// from the header nav (not just buried in My Tools). Renders the exact same
// <ValueTracker /> component the "Value Tracker" tab in ViewProfile.js uses —
// nothing about that tab changes, this is just a second entry point to the
// same component. Anonymous/logged-out preview behavior is stage 2.
class ValueTrackerPage extends Component {
  render() {
    return (
      <div style={{ backgroundColor: "#F9FAFF", minHeight: "70vh" }}>
        <Row className="margin-body-agent">
          <Col span={24} style={{ marginTop: "1vw", marginBottom: "0.5vw" }}>
            <h2 style={{ color: NAVY, fontWeight: 800 }}>📊 Value Tracker</h2>
          </Col>
        </Row>
        <Row className="margin-body-agent">
          <Col
            span={24}
            style={{
              background: "white",
              borderRadius: 10,
              marginBottom: "2vw",
              overflow: "hidden",
            }}
          >
            <ValueTracker />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withAppContext(withRouter(ValueTrackerPage));